var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'component-bouton-chrono',
		{ active: _vm.isActiveGrandePeriode },
		{ opened: _vm.opened },
		this.$store.getters.getIsMobile ? 'mobile' : ''
	],on:{"click":function($event){return _vm.setActiveGrandePeriodeIndex()}}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.imgUrl}})]),_c('div',{staticClass:"text"},[_c('div',{staticClass:"nom"},[_vm._v(_vm._s(_vm.grandeperiode.nom))]),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.grandeperiode.date))])]),_c('div',{staticClass:"absolute-image",style:('width: ' +
				_vm.grandeperiode.menuImageWidth +
				'px; top: ' +
				_vm.grandeperiode.menuImageDecal +
				'px;')},[_c('img',{attrs:{"src":_vm.absoluteImage}})])])}
var staticRenderFns = []

export { render, staticRenderFns }